import { useRouteLoaderData } from 'react-router'
import { type loader as rootLoader } from '#app/root.tsx'

type RootLoaderData = NonNullable<
	ReturnType<typeof useRouteLoaderData<typeof rootLoader>>
>

/**
 * UI-Sprache aus den Root-Loader-Daten innerhalb einer `meta()`-Funktion.
 *
 * `meta({ matches })` bekommt die Match-Daten als `unknown` — früher wurde das
 * projektweit mit `(root?.data as any)?.requestInfo?.uiLanguage` überbrückt (37×
 * ein echtes Typ-Loch). Hier einmal zentral und typisiert gegen den
 * Root-Loader narrowen.
 */
export function metaLocale(
	matches: Array<{ id: string; data: unknown } | null | undefined>,
): 'de' | 'en' {
	const root = matches.find((match) => match?.id === 'root')
	const data = root?.data as RootLoaderData | undefined
	return data?.requestInfo.uiLanguage === 'en' ? 'en' : 'de'
}
